import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import WooCommerceRegular from './woocommerce-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <WooCommerceRegular {...validProps} />;
}
SvgComponent.iconName = 'wooCommerceRegular';

export const WooCommerceRegularIcon = svgIconWrapper(SvgComponent);
